import root from 'window-or-global';
import {createClassLogger, Logger} from '../../utils/Logging';
import {NotificationBridge, NotificationResponseCallback} from '../notificationBridge';

const logger: Logger = createClassLogger('NotificationBridge:Mock');

const notificationMock: NotificationBridge = {
    registerResponseCallback: async (callback: NotificationResponseCallback): Promise<void> => {
        logger.info(
            'registerResponseCallback',
            'MOCKED, use __notificationResponseCallback to trigger callback'
        );
        root.__notificationResponseCallback = callback;
    }
};

export default notificationMock;
